import { render, staticRenderFns } from "./NewCrlDialog.vue?vue&type=template&id=b06d0f4c&scoped=true&"
import script from "./NewCrlDialog.vue?vue&type=script&lang=js&"
export * from "./NewCrlDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewCrlDialog.vue?vue&type=style&index=0&id=b06d0f4c&lang=scss&scoped=true&"
import style1 from "./NewCrlDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d0f4c",
  null
  
)

export default component.exports